// DO NOT EDIT !
export const BASE_URL = process.env.REACT_APP_API_HOST;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
export const RELEASE = process.env.REACT_APP_RELEASE;
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const PROJECT_NAME = "wg-fe-broker-onboarding";
